import {
  AccountLandingPage,
  TransactionHistoryPage,
  VerifyAccountPage,
  ProfilePage,
  EditProfilePage,
  ReferralPage,
  AddEmailPasswordPage,
  IframePage,
  SettingsPage,
  ContactUsPage,
  PaytmPaymentPage,
  CashfreePaymentPage,
  RevenueAnalyticsPage,
  PaymentSuccessPage,
  PaymentFailedPage,
  CashfreeCallbackPage,
  PaytmCallbackPage
} from '../container';
import {
  HomeTabCricket,
  HomeTabKabaddi,
  HomeTabSubstitute,
  HomeTabYesNo,
  HomeTabFootball,
  TeamPreview,
  ContestDetails,
  AllContestList,
  MyTeamsList,
  MyResultContestList,
  CreateTeamCricket,
  ChooseCaptainCricket,
  CreateTeamKabaddi,
  ChooseCaptainKabaddi,
  MyTeamsListSubstitute,
  CreateTeamSubstitute,
  ChooseCaptainSubstitute,
  SubstituteTeam,
  SubstituteTeamPlayer,
  FantasyHome,
  ContestShareLanding,
  GrandLeagueLeaderboard,
  MyQuestionList,
  WeekendLeaderboard,
  WeeklyLeaderboard,
  MyQueAns,
  YNMyResultContestList,
  YNAllContestList,
  YNContestDetails,
  YNPreviewAnswerList,
  CreateTeamFootball
} from '../fantasy_games';
import Poker from '../poker';
import { StackRouter, StackSwitch, StackRoute } from 'react-router-stack';
import HomePage from '../container/dashboard/home';
import SelectAvatar from '../container/select_avatar';
import Prizes from '../mini_games/game_info';
import LeaderBoard from '../mini_games/leaderboard';
import OfferWall from '../container/offer_wall';
import CouponsList from '../container/coupons_list';
import ComingSoon from '../container/coming_soon';
import MiniGames from '../mini_games/games';
import ViewAllGames from '../container/viewall_games';
import MyProfile from '../container/my_profile';
import MatchMaking from '../container/match_making';
import MatchMakingResult from '../container/match_making_result';
import SpinTheWheel from '../component/spinTheWheel';
import DailyRewards from '../container/daily_rewards';
import LeaderBoardPvpGames from '../container/leaderboard_pvp_games';

const Dashboard = () => {
  return (
    <StackRouter>
      <StackSwitch unmountOnExit={false} timeout={1} delay={0}>
        <StackRoute exact path="/wallet" component={AccountLandingPage} />
        <StackRoute exact path="/cricket" component={HomeTabCricket} />
        <StackRoute exact path="/kabaddi" component={HomeTabKabaddi} />
        <StackRoute exact path="/football" component={HomeTabFootball} />
        <StackRoute exact path="/substitute" component={HomeTabSubstitute} />
        <StackRoute exact path="/substitute" component={HomeTabSubstitute} />
        <StackRoute exact path="/yes_no" component={HomeTabYesNo} />
        <StackRoute exact unmountOnExit={true} path="/team_preview" component={TeamPreview} />
        <StackRoute exact path="/create_team" component={CreateTeamCricket} />
        <StackRoute exact path="/choose_captain" component={ChooseCaptainCricket} />
        <StackRoute exact path="/create_team_kabaddi" component={CreateTeamKabaddi} />
        <StackRoute exact path="/create_team_football" component={CreateTeamFootball} />
        <StackRoute exact path="/choose_captain_kabaddi" component={ChooseCaptainKabaddi} />
        <StackRoute exact path="/create_team_substitute" component={CreateTeamSubstitute} />
        <StackRoute exact path="/choose_captain_substitute" component={ChooseCaptainSubstitute} />
        <StackRoute exact path="/substitute_team" component={SubstituteTeam} />
        <StackRoute
          exact
          unmountOnExit={true}
          path="/substitute_team_player"
          component={SubstituteTeamPlayer}
        />
        <StackRoute exact path="/contest_details" component={ContestDetails} />
        <StackRoute exact path="/all_contest" component={AllContestList} />
        <StackRoute exact path="/my_teams" component={MyTeamsList} />
        <StackRoute exact path="/my_teams_substitute" component={MyTeamsListSubstitute} />
        <StackRoute exact path="/my_contests" component={MyResultContestList} />
        <StackRoute exact path="/contest_share_landing" component={ContestShareLanding} />
        <StackRoute
          exact
          unmountOnExit={true}
          path="/transaction_history"
          component={TransactionHistoryPage}
        />
        <StackRoute
          exact
          unmountOnExit={true}
          path="/verify_account"
          component={VerifyAccountPage}
        />
        <StackRoute exact path="/profile" component={ProfilePage} />
        <StackRoute exact unmountOnExit={true} path="/edit_profile" component={EditProfilePage} />
        <StackRoute exact unmountOnExit={true} path="/referral" component={ReferralPage} />
        <StackRoute exact path="/add_email_message" component={AddEmailPasswordPage} />

        <StackRoute exact unmountOnExit={true} path="/iframe_page" component={IframePage} />
        <StackRoute exact unmountOnExit={true} path="/settings" component={SettingsPage} />
        <StackRoute exact unmountOnExit={true} path="/contact_us" component={ContactUsPage} />
        <StackRoute exact unmountOnExit={true} path="/paytm_payment" component={PaytmPaymentPage} />
        <StackRoute
          exact
          unmountOnExit={true}
          path="/cashfree_payment"
          component={CashfreePaymentPage}
        />
        <StackRoute exact unmountOnExit={true} path="/success" component={PaymentSuccessPage} />
        <StackRoute exact unmountOnExit={true} path="/failure" component={PaymentFailedPage} />
        <StackRoute
          exact
          unmountOnExit={true}
          path="/revenue_analytics"
          component={RevenueAnalyticsPage}
        />
        <StackRoute exact path="/fantasy" component={FantasyHome} />
        <StackRoute exact path="/poker" component={Poker} />
        <StackRoute exact path="/cashfree_callback" component={CashfreeCallbackPage} />
        <StackRoute exact path="/paytm_callback" component={PaytmCallbackPage} />
        <StackRoute exact path="/leaderboard" component={GrandLeagueLeaderboard} />
        <StackRoute exact path="/my_question_list" component={MyQuestionList} />
        <StackRoute exact path="/weekend_leaderboard" component={WeekendLeaderboard} />
        <StackRoute exact path="/monthly_leaderboard" component={WeeklyLeaderboard} />
        <StackRoute exact path="/my_que_ans" component={MyQueAns} />
        <StackRoute exact path="/yn_all_contest" component={YNAllContestList} />
        <StackRoute exact path="/yn_contest_details" component={YNContestDetails} />
        <StackRoute exact path="/yn_my_contests" component={YNMyResultContestList} />
        <StackRoute exact path="/yn_preview_answer" component={YNPreviewAnswerList} />
        <StackRoute exact path="/select_avatar" component={SelectAvatar} />
        <StackRoute exact path="/prizes" component={Prizes} />
        <StackRoute exact path="/my_profile" component={MyProfile} />
        <StackRoute exact path="/leader_board" component={LeaderBoard} />
        <StackRoute exact path="/offer_wall" component={OfferWall} />
        <StackRoute exact path="/coupons" component={CouponsList} />
        <StackRoute exact path="/comingsoon" component={ComingSoon} />
        <StackRoute exact path="/games/:gameName" component={MiniGames} />
        <StackRoute exact path="/viewall/:gameName" component={ViewAllGames} />
        <StackRoute exact path="/match_making" component={MatchMaking} />
        <StackRoute exact path="/match_making_result" component={MatchMakingResult} />
        <StackRoute exact path="/spin_the_wheel" component={SpinTheWheel} />
        <StackRoute exact path="/daily_rewards" component={DailyRewards} />
        <StackRoute exact path="/leaderboard_games" component={LeaderBoardPvpGames} />
        <StackRoute exact path="/pvp_games" component={LeaderBoardPvpGames} />
        <StackRoute exact unmountOnExit={true} path="/*" component={HomePage} />
      </StackSwitch>
    </StackRouter>
  );
};
export default Dashboard;
